import ApiConstants from "../../../../../../utils/apiConstants";
import { axiosPost, axiosPatch } from "../../../../../../packages/apiPackage/axiosRequest";

async function UpdatePastIntroduction({ setBtnLoading, btnLoading, editionId,
    countries, participants, businessIdeas, speakers, content }) {

    if (!btnLoading) {
        setBtnLoading(true);
        try {
            await axiosPatch({
                endpoint: ApiConstants.UPDATE_PE_INTRODUCTION,
                jsonBody: JSON.stringify({
                    editionId: editionId,
                    countries: countries,
                    participants: participants,
                    businessIdeas: businessIdeas,
                    speakers: speakers,
                    content: content
                })
            })

            // console.log("response = ", response);
            setBtnLoading(false);
            return true;
        } catch (error) {
            console.log("error = ", error)
            setBtnLoading(false);
            if (!error?.response) {
                console.log("No server response.");
                // console.log("Login credit Expired.\nPlease Login Again!!!");
            } else if (error.response?.status === 404 || error.response?.status === 401) {
                console.log("Server Error !!! Try Logging in again.");
            } else {
                console.log("Login credit Expired.\nPlease Login Again!!!");
            }
            return false;
        }
    }
}

export default UpdatePastIntroduction;